'use client';

import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';

import { cn } from '@/lib/utils';

function Separator({
  className,
  orientation = 'horizontal',
  decorative = true,
  text,
  textClassName,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root> & { text?: string; textClassName?: string }) {
  if (text) {
    return (
      <div
        className={cn(
          'para:flex para:items-center para:gap-4 para:text-border para:text-2xs para:font-medium',
          { 'para:flex-row': orientation === 'horizontal', 'para:flex-col': orientation === 'vertical' },
          textClassName,
        )}
      >
        <SeparatorPrimitive.Root
          data-slot="separator-root"
          decorative={decorative}
          orientation={orientation}
          className={cn(
            'para:flex-1 para:bg-border para:shrink-0 para:data-[orientation=horizontal]:h-px para:data-[orientation=horizontal]:w-full para:data-[orientation=vertical]:h-full para:data-[orientation=vertical]:w-px',
            className,
          )}
          {...props}
        />
        {text}
        <SeparatorPrimitive.Root
          data-slot="separator-root"
          decorative={decorative}
          orientation={orientation}
          className={cn(
            'para:flex-1 para:bg-border para:shrink-0 para:data-[orientation=horizontal]:h-px para:data-[orientation=horizontal]:w-full para:data-[orientation=vertical]:h-full para:data-[orientation=vertical]:w-px',
            className,
          )}
          {...props}
        />
      </div>
    );
  }

  return (
    <SeparatorPrimitive.Root
      data-slot="separator-root"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'para:bg-border para:shrink-0 para:data-[orientation=horizontal]:h-px para:data-[orientation=horizontal]:w-full para:data-[orientation=vertical]:h-full para:data-[orientation=vertical]:w-px',
        className,
      )}
      {...props}
    />
  );
}

export { Separator };
